import React, { Component } from 'react';
import { Button, Card, CardBody, CardFooter, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import { Redirect } from "react-router-dom";
import axios from 'axios';
import  WebServiceList  from '../../webservices/WebServiceList'


class Login extends Component {

  constructor(props) {
    super(props);
    this.onChangeUserName = this.onChangeUserName.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
   
    this.enter = this.enter.bind(this);
    this.state = {
      redirect: false,
      username: "",
      password: ""
    }
  }


  onChangeUserName(e) {
    e.preventDefault();
    this.setState({
      username: e.target.value
    });
  }

  onChangePassword(e) {
    e.preventDefault();
    this.setState({
      password: e.target.value
    });
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to='/users-list' />
    }
  }

  enter(e) {
    /*Very important to preventDefault !!!!
    This is used to prevent many post request onClick 
    */
    e.preventDefault();

   
    const theUser =
    {
      username: this.state.username,
      password: this.state.password
    };  

       axios.post(WebServiceList.WsLogin(), theUser)
         .then(res => {
           console.log("Authentication Result:"+JSON.stringify(res.data));
           if (res.data.success === true) {
   
       
           localStorage.setItem("token",JSON.stringify(res.data.admin.token));
           localStorage.setItem("AdminId",JSON.stringify(res.data.admin.id));
           localStorage.setItem("AdminEmail",JSON.stringify(res.data.admin.email));
           localStorage.setItem("AdminName",JSON.stringify(res.data.admin.name));
           localStorage.setItem("AdminRole",JSON.stringify(res.data.admin.role));
           localStorage.setItem("loggedIn",true);
             this.setState({
               redirect: true
             })
           } else {
             this.setState({
               password: "",
               username:""
             });
           }
         });
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          {this.renderRedirect()}
          <Row className="justify-content-center">
            <Col md="9" lg="9" xl="9">
              <Card className="mx-4">
                <CardBody className="p-4">
                  <Form>
                    <h1>Login</h1>
                    <p className="text-muted">Login to your account</p>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-user"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="text" placeholder="Username" autoComplete="username"
                        value={this.state.username}
                        onChange={this.onChangeUserName} />
                    </InputGroup>

                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="password" placeholder="Password" autoComplete="new-password"
                        value={this.state.password}
                        onChange={this.onChangePassword}
                      />
                    </InputGroup>

                    <Button color="primary" block onClick={this.enter} >Login</Button>
                  </Form>
                </CardBody>
                <CardFooter className="p-4">
                  <Row>
                    <Col xs="12" sm="6">

                    </Col>
                    <Col xs="12" sm="6">

                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;
